import {
  CUSTOMER_FIRST_CREDIT_KEY,
  CUSTOMER_FIRST_PLAN_ID_KEY,
  isCustomerFirstEnrolled,
} from './registerFormHelpers';
import { enabledRegisterFields, normalizeFieldOptions } from './kioskLandingDefaults';
import { normalizeRegisterMobileValue } from '../../shared/mobileDigits';

function pick(customer, ...keys) {
  if (!customer || typeof customer !== 'object') return '';
  for (const key of keys) {
    const val = customer[key];
    if (val != null && String(val).trim() !== '') return String(val).trim();
  }
  return '';
}

function matchGenderOption(gender, field) {
  const raw = String(gender || '').trim();
  if (!raw) return '';
  const options = normalizeFieldOptions(field.options, field.type);
  const hit = options.find(
    (opt) => String(opt?.label || '').trim().toLowerCase() === raw.toLowerCase(),
  );
  return hit ? String(hit.label).trim() : raw;
}

/**
 * Merge NTLive / CRM customer payload into register form values (`{ custom: {} }`).
 * @returns {{ values: object, filledLabels: string[] }}
 */
export function applyNtliveCustomerToRegisterValues(registerForm, prevValues, customer) {
  const form = registerForm || { fields: [] };
  const enabled = enabledRegisterFields(form);
  const nextCustom = { ...(prevValues?.custom || {}) };

  const filledLabels = [];

  enabled.forEach((field) => {
    let val = '';
    switch (field.type) {
      case 'name':
        val = pick(customer, 'name', 'customer_name', 'full_name');
        break;
      case 'mobile':
        val = normalizeRegisterMobileValue(
          pick(customer, 'mobile', 'mobile_number', 'phone'),
        );
        break;
      case 'email':
        val = pick(customer, 'email', 'email_id');
        break;
      case 'gender':
        val = matchGenderOption(pick(customer, 'gender'), field);
        break;
      case 'dateOfBirth':
        val = pick(customer, 'dateOfBirth', 'date_of_birth', 'dob');
        break;
      case 'anniversaryDate':
        val = pick(customer, 'anniversaryDate', 'anniversary_date', 'anniversary');
        break;
      case 'skinType':
        val = pick(customer, 'skinType', 'skin_type');
        break;
      case 'membershipTier':
        val = pick(customer, 'membershipTier', 'customer_first_plan', 'membership_tier');
        break;
      case 'allergies':
        val = pick(customer, 'allergies');
        break;
      case 'preferenceNotes':
        val = pick(customer, 'preferenceNotes', 'preference_notes', 'notes');
        break;
      default:
        val = pick(customer, field.key);
        break;
    }
    if (!val) return;
    nextCustom[field.key] = val;
    filledLabels.push(field.label || field.key);
  });

  const planId = pick(customer, 'customerFirstPlanId', 'plan_id', 'member_id');
  const credit = pick(customer, 'customerFirstCreditLimit', 'credit_limit', 'plan_balance');
  const tierKey = enabled.find((f) => f.type === 'membershipTier')?.key;
  const tierVal = tierKey ? nextCustom[tierKey] : '';
  if (planId && (!tierVal || isCustomerFirstEnrolled(tierVal))) {
    nextCustom[CUSTOMER_FIRST_PLAN_ID_KEY] = planId;
    if (tierKey && !tierVal) nextCustom[tierKey] = 'Yes';
  }
  if (credit && tierKey && isCustomerFirstEnrolled(nextCustom[tierKey])) {
    nextCustom[CUSTOMER_FIRST_CREDIT_KEY] = credit;
  }

  return {
    values: { custom: nextCustom },
    filledLabels,
  };
}
